// ─────────────────────────────────────────────────────────────────────────────
// BELBIN IPS — 7 SECTIONS × 8 STATEMENTS
// Format: distribute exactly 10 points across 8 statements per section
// Inspired by Dr Meredith Belbin's Self-Perception Inventory (public domain concepts)
// ─────────────────────────────────────────────────────────────────────────────
export const SECTIONS = [
  {
    "id": "A",
    "situation": "What I believe I can contribute to a team:",
    "statements": [
      {
        "id": "A1",
        "text": "I think I can quickly see and take advantage of new opportunities.",
        "role": "RI"
      },
      {
        "id": "A2",
        "text": "I can work well with a very wide range of people.",
        "role": "TW"
      },
      {
        "id": "A3",
        "text": "Producing ideas is one of my natural assets.",
        "role": "PL"
      },
      {
        "id": "A4",
        "text": "My ability rests in being able to draw people out whenever I detect they have something of value to contribute.",
        "role": "CO"
      },
      {
        "id": "A5",
        "text": "My capacity to follow through has much to do with my personal effectiveness.",
        "role": "CF"
      },
      {
        "id": "A6",
        "text": "I am ready to face temporary unpopularity if it leads to worthwhile results.",
        "role": "SH"
      },
      {
        "id": "A7",
        "text": "I can usually sense what is realistic and likely to work.",
        "role": "IMP"
      },
      {
        "id": "A8",
        "text": "I can offer a reasoned case for alternative courses of action without introducing bias or prejudice.",
        "role": "ME"
      }
    ]
  },
  {
    "id": "B",
    "situation": "If I have a possible shortcoming in teamwork, it could be that:",
    "statements": [
      {
        "id": "B1",
        "text": "I am not at ease unless meetings are well structured and controlled and generally well conducted.",
        "role": "CF"
      },
      {
        "id": "B2",
        "text": "I am inclined to be too generous towards others who have a valid viewpoint that has not been given a proper airing.",
        "role": "CO"
      },
      {
        "id": "B3",
        "text": "I have a tendency to talk too much once the group gets on to new ideas.",
        "role": "RI"
      },
      {
        "id": "B4",
        "text": "My objective outlook makes it difficult for me to join in readily and enthusiastically with colleagues.",
        "role": "ME"
      },
      {
        "id": "B5",
        "text": "I am sometimes seen as forceful and authoritarian if there is a need to get something done.",
        "role": "SH"
      },
      {
        "id": "B6",
        "text": "I find it difficult to lead from the front, perhaps because I over-respond to atmosphere and feelings.",
        "role": "TW"
      },
      {
        "id": "B7",
        "text": "I am apt to get too caught up in ideas that occur to me and so lose track of what is happening.",
        "role": "PL"
      },
      {
        "id": "B8",
        "text": "My colleagues tend to see me as worrying unnecessarily over detail and the possibility that things may go wrong.",
        "role": "IMP"
      }
    ]
  },
  {
    "id": "C",
    "situation": "When involved in a project with other people:",
    "statements": [
      {
        "id": "C1",
        "text": "I have an aptitude for influencing people without pressurising them.",
        "role": "CO"
      },
      {
        "id": "C2",
        "text": "My general vigilance prevents careless mistakes and omissions being made.",
        "role": "CF"
      },
      {
        "id": "C3",
        "text": "I am ready to press for action to make sure that the meeting does not waste time or lose sight of the main objective.",
        "role": "SH"
      },
      {
        "id": "C4",
        "text": "I can be counted on to contribute something original.",
        "role": "PL"
      },
      {
        "id": "C5",
        "text": "I am always ready to back a good suggestion in the common interest.",
        "role": "TW"
      },
      {
        "id": "C6",
        "text": "I am keen to look for the latest in new ideas and developments.",
        "role": "RI"
      },
      {
        "id": "C7",
        "text": "I believe my capacity for cool judgement is appreciated by others.",
        "role": "ME"
      },
      {
        "id": "C8",
        "text": "I can be relied upon to see that all essential work is organised.",
        "role": "IMP"
      }
    ]
  },
  {
    "id": "D",
    "situation": "My characteristic approach to group work is that:",
    "statements": [
      {
        "id": "D1",
        "text": "I have a quiet interest in getting to know colleagues better.",
        "role": "TW"
      },
      {
        "id": "D2",
        "text": "I do not hesitate to challenge the views of others or to hold a minority view myself.",
        "role": "SH"
      },
      {
        "id": "D3",
        "text": "I can usually find a line of argument to refute unsound propositions.",
        "role": "ME"
      },
      {
        "id": "D4",
        "text": "I think I have a talent for making things work once a plan has to be put into operation.",
        "role": "IMP"
      },
      {
        "id": "D5",
        "text": "I have a tendency to avoid the obvious and to come out with the unexpected.",
        "role": "PL"
      },
      {
        "id": "D6",
        "text": "I bring a touch of perfectionism to any team job I undertake.",
        "role": "CF"
      },
      {
        "id": "D7",
        "text": "I am ready to make use of contacts outside the group itself.",
        "role": "RI"
      },
      {
        "id": "D8",
        "text": "While I am interested in all views I have no hesitation in making up my mind once a decision has to be made.",
        "role": "CO"
      }
    ]
  },
  {
    "id": "E",
    "situation": "I gain satisfaction in a job because:",
    "statements": [
      {
        "id": "E1",
        "text": "I enjoy analysing situations and weighing up all the possible choices.",
        "role": "ME"
      },
      {
        "id": "E2",
        "text": "I am interested in finding practical solutions to problems.",
        "role": "IMP"
      },
      {
        "id": "E3",
        "text": "I like to feel I am fostering good working relationships.",
        "role": "TW"
      },
      {
        "id": "E4",
        "text": "I can have a strong influence on decisions.",
        "role": "SH"
      },
      {
        "id": "E5",
        "text": "I meet people who may offer something new to me.",
        "role": "RI"
      },
      {
        "id": "E6",
        "text": "I can get people to agree on a necessary course of action.",
        "role": "CO"
      },
      {
        "id": "E7",
        "text": "I feel in my element where I can give a task my full attention.",
        "role": "CF"
      },
      {
        "id": "E8",
        "text": "I like to find a field that stretches my imagination.",
        "role": "PL"
      }
    ]
  },
  {
    "id": "F",
    "situation": "If I am suddenly given a difficult task with limited time and unfamiliar people:",
    "statements": [
      {
        "id": "F1",
        "text": "I would feel like retiring to a corner to devise a way out of the impasse before developing a line.",
        "role": "PL"
      },
      {
        "id": "F2",
        "text": "I would be ready to work with the person who showed the most positive approach.",
        "role": "TW"
      },
      {
        "id": "F3",
        "text": "I would find a way of reducing the size of the task by establishing what different individuals might best contribute.",
        "role": "CO"
      },
      {
        "id": "F4",
        "text": "My natural sense of urgency would help to ensure that we did not fall behind schedule.",
        "role": "SH"
      },
      {
        "id": "F5",
        "text": "I believe I would keep cool and maintain my capacity to think straight.",
        "role": "ME"
      },
      {
        "id": "F6",
        "text": "I would retain a steadiness of purpose in spite of the pressures.",
        "role": "IMP"
      },
      {
        "id": "F7",
        "text": "I would be prepared to take a positive lead if I felt the group was making no progress.",
        "role": "CF"
      },
      {
        "id": "F8",
        "text": "I would open up discussions with a view to stimulating new thoughts and getting something moving.",
        "role": "RI"
      }
    ]
  },
  {
    "id": "G",
    "situation": "In relation to the problems I experience when working in groups:",
    "statements": [
      {
        "id": "G1",
        "text": "I am apt to show my impatience with those who are obstructing progress.",
        "role": "SH"
      },
      {
        "id": "G2",
        "text": "Others may criticise me for being too analytical and insufficiently intuitive.",
        "role": "ME"
      },
      {
        "id": "G3",
        "text": "My desire to ensure that work is properly done can hold up proceedings.",
        "role": "CF"
      },
      {
        "id": "G4",
        "text": "I tend to get bored rather easily and rely on one or two stimulating members to spark my enthusiasm.",
        "role": "RI"
      },
      {
        "id": "G5",
        "text": "I find it difficult to get started unless the goals are clear.",
        "role": "IMP"
      },
      {
        "id": "G6",
        "text": "I am sometimes poor at explaining and clarifying complex points that occur to me.",
        "role": "PL"
      },
      {
        "id": "G7",
        "text": "I am conscious of demanding from others the things I cannot do myself.",
        "role": "CO"
      },
      {
        "id": "G8",
        "text": "I hesitate to get my points across when I run up against real opposition.",
        "role": "TW"
      }
    ]
  }
];

export const TOTAL_SECTIONS = SECTIONS.length;
export const POINTS_PER_SECTION = 10;
export const STATEMENTS_PER_SECTION = 8;
